import { Component, forwardRef, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { AbstractCustomControlComponent } from "../abstract-custom-control/abstract-custom-control.component";
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Observable } from "rxjs";
import { Comune } from "src/app/models/comune.model";
import { ComuneService } from "src/app/services/comune.service";
import { debounceTime, distinctUntilChanged, filter, map, skip, startWith, switchMap } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { MatAutocompleteSelectedEvent } from "@angular/material";
import { Page } from "src/app/models/page.model";

@Component({
  selector: "app-comune-autocomplete",
  templateUrl: "./comune-autocomplete.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComuneAutocompleteComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ComuneAutocompleteComponent),
      multi: true,
    },
  ],
})
export class ComuneAutocompleteComponent extends AbstractCustomControlComponent implements OnInit
{
  private _provincia: string;

  @Input() set provincia(value: string) {
    this._provincia = value;

    if (this.selectedComune && !this.selectedComune.disabled) {
      this.selectedComune.setValue('');
    }
  }
  @Input() value: string;
  @Output() comuneSelected = new EventEmitter<Comune>();
  @Output() isComuneFound = new EventEmitter<boolean>();

  comuni: Observable<Comune[]>;
  selectedComune = new FormControl();

  get provincia(): string {
    return this._provincia;
  }

  constructor(private comuneService: ComuneService) {
    super();
  }

  ngOnInit() {
    this.comuni = this.selectedComune.valueChanges.pipe(
      this.value ? startWith(this.value) : startWith(''),
      skip(this.value ? 1 : 0),
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => value !== 'Estero'),
      filter(value => typeof value === 'string'),
      switchMap(value => {
        let params = new HttpParams().set('descrComune', value);
        
        if (this.provincia) {
          params = params.set('descrProvincia', this.provincia);
        }

        return this.comuneService.getComuniList(params);
      }),
      map(res => res.content),
    );

    this.selectedComune.valueChanges.pipe(
      skip(1),
      filter(value => typeof value === 'string')
    ).subscribe(() => {
      this.writeValue(null);

      if (this.selectedComune.enabled) {
        this.comuneSelected.emit(null);
      }
    })

    if (this.value) {
      if (this.value !== 'Estero') {
        this.selectedComune.patchValue(this.value);
      }

      const comune: Observable<Page<Comune>> = this.comuneService.getComuniList(new HttpParams().set('descrComune', this.value));
      comune.subscribe(value => {
        if (!value.content.some(c => c.denominazione === this.value)) {
          this.isComuneFound.emit(false);
        } else {
          this.isComuneFound.emit(true);
        }
      })
    }
  }

  onSelectComune(selected: MatAutocompleteSelectedEvent) {
    const comune: Comune = selected.option.value;
    this.writeValue(comune.denominazione);
    this.comuneSelected.emit(comune);
  }

  displayFn(value: Comune | string): string {
    if (typeof value === 'string') {
      return value;
    }

    return value ? value.denominazione : '';
  }

  setDisabledState(disabled: boolean): void {
    super.setDisabledState(disabled);

    if (disabled) {
      this.selectedComune.disable();
    } else {
      this.selectedComune.enable();
    }
  }
}
